<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>
        Taxes
      </v-toolbar-title>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <tax-rate-drop-down
        :multiple="true"
        :init-tax-rates="product.defaultTaxRates || []"
        @select-item="onSelectTaxRates"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import TaxRateDropDown from "../TaxRate/TaxRateDropDown"

export default {
  components: { TaxRateDropDown  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onSelectTaxRates(taxRates){
      this.$emit('change', taxRates)
    }
  }
}
</script>
